<template>
  <div>
    <transition name="fade">
      <div class="hamburger-light" v-show="$store.state.showHamburgerMenu" v-on:click="$store.commit('setShowHamburgerMenu', false)">
      </div>
    </transition>
    <transition name="fade">
      <div class="hamburger-menu" v-if="$store.state.showHamburgerMenu">
        <div class="close-box small grey" v-on:click="hideThis"></div>
        <div class="ham-logo" v-on:click="hideThis">
          <ix-router-link :to="currentHome"><img :src="logo.logo" :alt="logo.alt" width="200" /></ix-router-link>
        </div>
        <div class='hamburger-list' v-on:click="hideThis">
          <div class="device-only">
            <div class="hamburger-item"><ix-router-link to="/artists">{{ $nippets.illustrators }}</ix-router-link></div>
            <div class="hamburger-item" v-on:click.stop="showStyles">
              <ix-router-link to="/styles" event="none">{{ $nippets.styles }}</ix-router-link>
            </div>
            <div class="hamburger-item"><ix-router-link to="/animators">{{ $nippets.animators }}</ix-router-link></div>
          </div>
          <div class="hamburger-item"><ix-router-link to="/about">{{ $nippets.aboutUs }}</ix-router-link></div>
          <div class="hamburger-item"><ix-router-link to="/news">{{ $nippets.news }}</ix-router-link></div>
          <div class="hamburger-item"><ix-router-link to="/ten-million-trees">{{ $nippets.tenMillionTrees }}</ix-router-link></div>
          <div class="hamburger-item"><ix-router-link to="/videos">{{ $nippets.videos }}</ix-router-link></div>
          <div class="hamburger-item"><ix-router-link to="/applications">{{ $nippets.artistApplications }}</ix-router-link></div>
          <div class="hamburger-item"><ix-router-link to="/vacancies">{{ $nippets.vacancies }}</ix-router-link></div>
          <div class="hamburger-item"><router-link :to="$ixr.contactLink">{{ $nippets.contact }}</router-link></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import logos from './logos.js'
export default {
  props: {
    animation: Boolean
  },
  computed: {
    currentHome () {
      return this.animation ? '/animation': '/'
    },
    logo () {
      if(this.animation) {
        return logos.anim
      }
      return logos.illus
    }
  },
  methods: {
    hideThis () {
      this.$store.commit('setShowHamburgerMenu', false)
    },
    showStyles: async function () {
      this.$emit('styleClick')
      this.hideThis()
    }
  }
}
</script>

<style>
.hidescroll{
  display:none;
}

.scrolled .hidescroll{
  display:block;
}

.hamburger-light{
  position:fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  box-sizing:border-box;
  z-index:90;
  background-color:#00000088;
  cursor:pointer;
}

.hamburger-menu{
  position:absolute;
  top:0;
  right:0;
  width:360px;
  z-index:100;
  background-color:#fff;
  padding:50px;
  max-width:100%;
  box-sizing:border-box;
}

.hamburger-list{
  padding:10px 0;
  overflow-y:auto;
  max-height:calc(90vh - 100px);
}

.hamburger-item{
  padding:10px 0;
  display:flex;
  align-items:center;
}

.hamburger-item div:first-child{
  margin-right:10px;
}

.hamburger-item a{
  text-decoration:none;
  color:#000;
}

.hamburger-item a:hover{
  color:#ce0e2d;
}

.device-only{
  display:none;
}

@media screen and (max-width:1024px){
  .device-only{
    display:block;
  }
}

@media screen and (max-width:640px) {
  .hamburger-menu{
    padding:10px;
  }

  
}
</style>
